<template>
	<div class="chat-text-message">
		<span v-html="html" :class="bgClass"></span>
	</div>
</template>
<script>
import { textReplaceLink } from '@/utils/functions'
export default {
	props:{
		content: {
			require:true
		},
		bgClass: {
		  type: String
		},
	},
	watch:{
		'content':{
			handler(val){
				 this.html = textReplaceLink(val)
			},
			immediate:true
		}
	},
	data(){
		return{
			html:''
		}
	}
}
</script>
<style scoped lang="scss">
.chat-text-message {
	display: flex;
	align-items: center;
	max-width: 300px;
	word-break: break-all;
	.left,.right {
		padding: 6px 10px;
		border-radius: 4px;
	}
	.left {
		background-color: #F6F7F9;
	}
	.right {
		background-color: #EDF5FF;
	}
}
</style>